import React from 'react';
import { Link } from 'react-router-dom';
import { Bot, ArrowRight } from 'lucide-react';
import { KIAN_FEED_EVENTS } from '@/data/venddi';

export default function VenddiKian() {
  return (
    <div className="relative overflow-hidden bg-gradient-to-br from-[#0A2540] via-[#0A2540] to-[#050E1F] text-white">
      <div className="absolute inset-0 noise-texture opacity-40" />
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#38BDF8]/15 blur-3xl rounded-full" />
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-24">
        <div className="grid lg:grid-cols-[1fr_1.2fr] gap-12 items-center">
          <div className="text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 mb-5 text-[10px] font-bold uppercase tracking-[0.18em] text-[#38BDF8] bg-[#38BDF8]/10 border border-[#38BDF8]/20 rounded-full">
              <Bot className="w-3.5 h-3.5" />KIAN™ · CHIEF AI OFFICER
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-[1.05] mb-5" style={{ fontFamily: 'Syne,sans-serif' }}>
              Kian orquesta<br />
              <span className="text-[#38BDF8]">cada transacción</span>,<br />
              cada kiosco, en vivo.
            </h2>
            <p className="text-base text-slate-300 leading-relaxed mb-6">
              No es un chatbot. Kian es la capa de IA que vive dentro de Venddi: supervisa el flujo de cada kiosco 24/7, detecta anomalías, optimiza el menú según conversión, predice picos de demanda y alerta a gerencia por WhatsApp antes de que algo falle.
            </p>
            <Link to="/empresa/equipo#kian" className="inline-flex items-center gap-2 text-sm font-bold text-[#38BDF8] hover:underline">
              Conoce más de Kian <ArrowRight className="w-4 h-4" />
            </Link>
          </div>

          <div className="relative">
            <div className="p-5 sm:p-6 rounded-2xl bg-white/5 backdrop-blur border border-white/10 shadow-2xl">
              <div className="flex items-center justify-between mb-4 pb-3 border-b border-white/10">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-lg bg-[#38BDF8] flex items-center justify-center"><Bot className="w-4 h-4 text-[#0A2540]" /></div>
                  <div>
                    <div className="text-xs font-bold text-[#38BDF8] uppercase">Kian Ops Feed</div>
                    <div className="text-[10px] text-slate-400">Tiempo real · Piloto multi-kiosco</div>
                  </div>
                </div>
                <span className="flex items-center gap-1 text-[10px] text-emerald-400"><span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />LIVE</span>
              </div>
              <div className="space-y-2.5">
                {KIAN_FEED_EVENTS.map((m, i) => (
                  <div key={i} className="flex items-start gap-3 p-2.5 rounded-lg bg-white/5 hover:bg-white/10 transition-colors">
                    <div className="w-7 h-7 rounded-md flex items-center justify-center shrink-0" style={{ background: `${m.c}22` }}>
                      <m.icon className="w-3.5 h-3.5" style={{ color: m.c }} />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="text-xs text-slate-200 leading-snug">{m.txt}</div>
                      <div className="text-[10px] text-slate-500 mt-0.5">hace {m.t}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
